import React from 'react'
import Avatar from '@components/@vuexy/avatar/AvatarComponent'
// import { ASSET_TYPE } from '@common/constants'
import { isUndefined } from '@common/utils'
import imgDefault from '@assets/img/img_default.png'

export default ({ assetTypeName, roundIcon, imageFilePath }) => {
  // const assetType = ASSET_TYPE[assetTypeName] || ASSET_TYPE['Undefined']
  // let assetImage = isUndefined(imageFilePath) ? assetType.icon : imageFilePath

  if (roundIcon) return <Avatar size='lg' img={!isUndefined(imageFilePath) ? imageFilePath : imgDefault} />

  return (
    <div>
      <img className='equipment-icon' src={!isUndefined(imageFilePath) ? imageFilePath : imgDefault} title={assetTypeName} />
    </div>
  )
}
